<template>
  <v-text-field
    ref="field"
    v-bind="$attrs"
    :value="displayValue"
    type="text"
    inputmode="decimal"
    v-on="passThroughListeners"
    @input="onInput"
  ></v-text-field>
</template>

<script>
import CurrencyUtils from '../utils/currency.utils';

/**
 * `v-text-field` para montos que muestra los miles separados mientras se escribe
 * ("200.000") y emite el número (200000), o null si queda vacío. Las `rules`
 * reciben el texto formateado: para comparar montos, leer el modelo, no `v`.
 */
export default {
  name: 'AmountTextField',
  inheritAttrs: false,
  props: {
    value: { type: [Number, String], default: null },
    thousandsSeparator: { type: String, default: '.' },
    decimalSeparator: { type: String, default: ',' }
  },
  data() {
    return { displayValue: this.format(this.value) };
  },
  computed: {
    passThroughListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    }
  },
  watch: {
    value(val) {
      if (this.parse(this.displayValue) !== this.toNumber(val)) {
        this.displayValue = this.format(val);
      }
    }
  },
  methods: {
    validate(...args) {
      return this.$refs.field.validate(...args);
    },
    onInput(text) {
      const formatted = this.formatTyped(text);
      // Si el formato no cambia el valor (p. ej. se tecleó una letra), Vuetify no
      // repinta el input: se pasa por el texto crudo para forzarlo.
      this.displayValue = text;
      this.$nextTick(() => {
        this.displayValue = formatted;
      });
      this.$emit('input', this.parse(formatted));
    },
    format(value) {
      const number = this.toNumber(value);
      if (number === null) return '';
      return this.formatPlain(String(number));
    },
    formatTyped(text) {
      return this.formatPlain(CurrencyUtils.toPlainAmount(text, this.decimalSeparator));
    },
    formatPlain(plain) {
      return CurrencyUtils.formatDecimalPrice(plain, {
        thousandsSeparator: this.thousandsSeparator,
        decimalSeparator: this.decimalSeparator
      });
    },
    parse(text) {
      return this.toNumber(CurrencyUtils.toPlainAmount(text, this.decimalSeparator));
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') return null;
      const number = Number(value);
      return Number.isNaN(number) ? null : number;
    }
  }
};
</script>
